import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferStack() {
  const handleCTAClick = () => {
    trackAddToCart();
  };
  return <section className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-184">
      <div className="max-w-2xl mx-auto" data-id="element-185">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-186">
          TODO LO QUE RECIBES
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-187">
          Todo lo que recibes hoy:
        </h2>

        {/* Product Cards */}
        <div className="space-y-4 mb-10" data-id="element-188">
          {/* Main Product */}
          <div className="bg-navy-light rounded-xl border-l-4 border-cyan p-6 relative" data-id="element-189">
            <span className="absolute top-4 right-4 bg-cyan/20 text-cyan text-xs font-semibold px-3 py-1 rounded-full" data-id="element-190">
              PRODUCTO PRINCIPAL
            </span>
            <div className="flex flex-col md:flex-row gap-4" data-id="element-191">
              <img src="https://cdn.magicpatterns.com/uploads/hY2jRSXJfE7JrLSyrvaahh/portada.png" alt="Guía Principal" className="w-24 h-auto rounded-lg" data-id="element-192" />
              <div className="flex-1" data-id="element-193">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-194">
                  📘 Guía Principal
                </h3>
                <p className="text-cyan text-sm mb-2" data-id="element-195">
                  Duermes… Pero No Descansas
                </p>
                <p className="text-gray-300 text-sm" data-id="element-196">
                  60 páginas. Entiende tu patrón, aplica el protocolo completo
                  de 14 noches y mide tu progreso con métricas reales.
                </p>
              </div>
              <div className="text-right" data-id="element-197">
                <span className="text-white font-bold text-lg" data-id="element-198">$14.99</span>
              </div>
            </div>
          </div>

          {/* Bonus 1 */}
          <div className="bg-navy-light rounded-xl border-l-4 border-cta p-6 relative" data-id="element-199">
            <span className="absolute top-4 right-4 bg-cta/20 text-cta text-xs font-semibold px-3 py-1 rounded-full" data-id="element-200">
              🎁 BONO #1 — GRATIS
            </span>
            <div className="flex flex-col md:flex-row gap-4" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/cfQE4s8KvbJoQQLr8vRRZ4/portada_bono_1.png" alt="Workbook Protocolo 14 Noches" className="w-24 h-auto rounded-lg" data-id="element-202" />
              <div className="flex-1" data-id="element-203">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-204">
                  📋 Workbook Protocolo 14 Noches
                </h3>
                <p className="text-cyan text-sm mb-2" data-id="element-205">
                  Mi Bitácora de Recuperación
                </p>
                <p className="text-gray-300 text-sm" data-id="element-206">
                  16 páginas. Rastrea tu progreso noche a noche. Métricas
                  diarias. Ajustes personalizados. Convierte la guía en un
                  sistema.
                </p>
              </div>
              <div className="text-right" data-id="element-207">
                <span className="text-gray-500 line-through text-sm" data-id="element-208">
                  $7.99
                </span>
                <span className="text-cta font-bold ml-2" data-id="element-209">GRATIS</span>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-navy-light rounded-xl border-l-4 border-cta p-6 relative" data-id="element-210">
            <span className="absolute top-4 right-4 bg-cta/20 text-cta text-xs font-semibold px-3 py-1 rounded-full" data-id="element-211">
              🎁 BONO #2 — GRATIS
            </span>
            <div className="flex flex-col md:flex-row gap-4" data-id="element-212">
              <img src="https://cdn.magicpatterns.com/uploads/b4mwDwZajMzU1ixKXkSs8t/portada_bono_2.png" alt="Reset de 7 Minutos" className="w-24 h-auto rounded-lg" data-id="element-213" />
              <div className="flex-1" data-id="element-214">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-215">
                  ⚡ Reset de 7 Minutos
                </h3>
                <p className="text-cyan text-sm mb-2" data-id="element-216">
                  7 Minutos para Apagar la Alerta
                </p>
                <p className="text-gray-300 text-sm" data-id="element-217">
                  1 página imprimible. Para esta misma noche. Los 4 pasos
                  exactos para enviar una señal de seguridad a tu sistema
                  nervioso antes de dormir.
                </p>
              </div>
              <div className="text-right" data-id="element-218">
                <span className="text-gray-500 line-through text-sm" data-id="element-219">
                  $4.99
                </span>
                <span className="text-cta font-bold ml-2" data-id="element-220">GRATIS</span>
              </div>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-navy-light rounded-xl border-l-4 border-cta p-6 relative" data-id="element-221">
            <span className="absolute top-4 right-4 bg-cta/20 text-cta text-xs font-semibold px-3 py-1 rounded-full" data-id="element-222">
              🎁 BONO #3 — GRATIS
            </span>
            <div className="flex flex-col md:flex-row gap-4" data-id="element-223">
              <img src="https://cdn.magicpatterns.com/uploads/iHX1fmPQH5nMPAgRihk8Ee/portada_bono_3.png" alt="Kit de Emergencias Nocturnas" className="w-24 h-auto rounded-lg" data-id="element-224" />
              <div className="flex-1" data-id="element-225">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-226">
                  🚨 Kit de Emergencias Nocturnas
                </h3>
                <p className="text-cyan text-sm mb-2" data-id="element-227">S.O.S. 3:00 AM</p>
                <p className="text-gray-300 text-sm" data-id="element-228">
                  12 páginas. Para las 3am. Para cuando el cerebro no para. 5
                  escenarios con instrucciones exactas de 90 segundos.
                </p>
              </div>
              <div className="text-right" data-id="element-229">
                <span className="text-gray-500 line-through text-sm" data-id="element-230">
                  $7.99
                </span>
                <span className="text-cta font-bold ml-2" data-id="element-231">GRATIS</span>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Box */}
        <div className="border-2 border-cta bg-navy-light rounded-xl p-8 text-center mb-8" data-id="element-232">
          <p className="text-gray-400 text-lg mb-2" data-id="element-233">
            VALOR TOTAL: <span className="line-through" data-id="element-234">$35.96</span>
          </p>
          <div className="border-t border-white/20 my-4" data-id="element-235"></div>
          <p className="text-white text-3xl md:text-4xl font-bold mb-2" data-id="element-236">
            PRECIO HOY: $6.39
          </p>
          <div className="border-t border-white/20 my-4" data-id="element-237"></div>
          <p className="text-cta text-xl font-semibold" data-id="element-238">AHORRAS: $29.57</p>
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-239">
          <a href="https://novadigitalventures.com/cart/42535353811015:1" onClick={handleCTAClick} className="animate-pulse-cta bg-cta text-navy font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full hover:bg-cta/90 transition-colors mb-6 w-full md:w-auto inline-block text-center" data-id="element-240">
            Quiero el protocolo completo →
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-white/80" data-id="element-241">
            <span data-id="element-242">⚡ Descarga instantánea</span>

            <span data-id="element-243">🔒 Pago 100% seguro</span>
            <span data-id="element-244">🛡️ Garantía 30 días</span>
          </div>
        </div>
      </div>
    </section>;
}